<template>
  <div class="about">
    <!-- <van-icon name="checked" style="font-size:100px" color="#e2000e" />
    <div class="tip">申请成功</div> -->
    <van-loading type="spinner" color="#1989fa" />
  </div>
</template>
<script>
export default {
  mounted() {
    this.onLoad(this.$route.query.id)
  },
  methods: {
    onLoad(id) {
      this.axios
        .get('BaiduAi/getResultsSmple', { params: { applyId: id } })
        .then(res => {
          //更新状态
          this.$router.replace({
            path: '/appointment/info',
            query: { id: id }
          })
        })
        .catch(error => {
        })
    }
  }
}
</script>
<style lang="less" scoped>
.about {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.tip {
  line-height: 50px;

}
</style>